import { render, staticRenderFns } from "./AdiantamentosView.vue?vue&type=template&id=45ac5380&scoped=true"
import script from "./AdiantamentosView.vue?vue&type=script&lang=js"
export * from "./AdiantamentosView.vue?vue&type=script&lang=js"
import style0 from "./AdiantamentosView.vue?vue&type=style&index=0&id=45ac5380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac5380",
  null
  
)

export default component.exports